export class Navigation {
    private _navigationToggleElements: NodeListOf<Element>
    private _mobileNavigationElement: Element | null;

    constructor(navigationToggleElements: NodeListOf<Element>) {
        this._navigationToggleElements = navigationToggleElements;
        this._mobileNavigationElement = document.querySelector('[data-module-mobile-navigation]');
    }

    public init() {
        this._navigationToggleElements.forEach(navigationToggleElement => {
            navigationToggleElement.addEventListener('click', this.toggleMobileNavigation.bind(this));
        });
    }

    private toggleMobileNavigation() {
        if (this._mobileNavigationElement) {
            this._mobileNavigationElement?.classList.toggle('active');
        }
    }
}